import React, { ReactNode, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-regular-svg-icons";
import "./websiteBuilderPanelContent.scss";

interface IWebsiteBuilderPanelContentProps {
  title: string;
  sections: ReactNode[];
  footer?: ReactNode;
  closePanel: () => void;
}

export function WebsiteBuilderPanelContent(props: IWebsiteBuilderPanelContentProps) {
  const { title, sections, footer, closePanel } = props;

  useEffect(() => {
    function handleKeydown(event: KeyboardEvent) {
      if (event.key === "Escape") {
        closePanel();
      }
    }

    document.addEventListener("keydown", handleKeydown);

    return () => document.removeEventListener("keydown", handleKeydown);
  }, [closePanel]);

  return (
    <div
      className="website-builder-panel-content"
      onMouseOver={e => e.stopPropagation()}
      onMouseOut={e => e.stopPropagation()}
      onDoubleClick={e => e.stopPropagation()}
      onPointerDown={e => e.stopPropagation()}
      onContextMenu={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div className="panel-content-header">
        <h3>{title}</h3>
        <button
          type="button"
          className="panel-content-close"
          onClick={closePanel}
        >
          <FontAwesomeIcon icon={faClose} />
        </button>
      </div>
      <div className="panel-content-sections">
        {sections.map((section, index) => (
          <React.Fragment key={index}>
            <div className="panel-content-section">{section}</div>
            {index < sections.length - 1 && <hr className="panel-content-section-divider" />}
          </React.Fragment>
        ))}
      </div>
      {footer != null && <div className="panel-content-footer">{footer}</div>}
    </div>
  );
}
